import React from "react";

const tone = (p) => (p >= 85 ? "bg-[#C86235] text-white" : p >= 50 ? "bg-[#E9C9A8] text-[#45423C]" : p > 0 ? "bg-[#F1EDE6] text-[#45423C]" : "bg-white text-[#B9AE9A]");

export const OccCell = ({ d, compact }) => (
  <div className={`rounded-md px-1 py-1 text-center leading-tight ${tone(d.pct)}`} data-testid={`occ-${d.date}`}
    title={`${d.booked}/${d.total} βίλες · ${d.guests} άτομα · ${d.arrivals} αφίξεις · ${d.departures} αναχωρήσεις`}>
    <div className="text-[11px] font-semibold tabular">{d.pct}%</div>
    <div className="text-[9px] tabular opacity-80">{d.booked}/{d.total}{compact ? "" : ` · ${d.guests}άτ`}</div>
    {!compact && (d.arrivals > 0 || d.departures > 0) && (
      <div className="text-[9px] tabular opacity-80">↓{d.arrivals} ↑{d.departures}</div>
    )}
  </div>
);
